import React, { useState } from 'react';
import { useParams } from 'react-router-dom';

const BASE_VIDEO = '/assets/videos/';

function PlayIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="33" height="39" viewBox="0 0 33 39" fill="none">
      <path d="M0.0849609 38.7498V0.558594L32.7127 19.6523L0.0849609 38.7498Z" fill="white"/>
    </svg>
  );
}

function CloseIcon() {
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none">
      <circle cx="18" cy="18" r="18" fill="rgba(255,255,255,0.15)" />
      <path d="M11 11L25 25M25 11L11 25" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" />
    </svg>
  );
}

const SOLUTIONS = {
  'ig-kds': {
    pageClass: 'IGKDSFPage',
    logo: '/assets/higher-ed/solutions/AgilysysIGKDS.svg',
    logoAlt: 'Agilysys IG KDS',
    videoUrl: BASE_VIDEO + 'InteractiveIGKDS.mp4',
    texts: [
      'An integrated kitchen display system to manage kitchen orders. The Expo Display shows all orders for the kitchen, allowing an expediter to control the flow of orders and preparation times, while an Order Status Display shows diners the status of their orders and which can be shown in an ADA format.',
      'For IG OnDemand customers, KDS can also be deployed in the cloud with support for multiple KDS stations, routing, scheduled orders, a queue tab and sending an SMS message when orders are bumped. The result is a seamless order flow from order taking to kitchen management and diner notification.',
    ],
    img1: '/assets/higher-ed/solutions/IGKitchen1.png',
  },
  eatec: {
    pageClass: 'eatecPage',
    logo: '/assets/higher-ed/solutions/AgilysysEatec.svg',
    logoAlt: 'Agilysys Eatec',
    videoUrl: BASE_VIDEO + 'InteractiveEatec.mp4',
    texts: [
      'A modern, advanced inventory & procurement solution to help control the quality and consistency of your product purchases and inventory levels to ensure you have all of the ingredients for food & retail management success.\n\nThe solution helps to maximize every dollar by supporting in-house production and cycle menu management with plate cost analysis and integrated procurement, reducing waste, spoilage, theft and overstock.\n\nWith robust recipe and nutritional information management and a built-in banquet catering module, Eatec inventory & procurement gives you the complete picture and full control.',
    ],
    img1: '/assets/higher-ed/solutions/eatec1.png',
    img2: '/assets/higher-ed/solutions/eatec2.png',
  },
  'info-genesis': {
    pageClass: 'infoGenesisFPage',
    logo: '/assets/higher-ed/solutions/AgilysysInfoGenesis.svg',
    logoAlt: 'Agilysys InfoGenesis',
    videoUrl: BASE_VIDEO + 'InteractiveInfoGenesis.mp4',
    texts: [
      'An award-winning enterprise-class point-of-sale solution that processes transactions in the highest volume, most demanding environments.',
      'A comprehensive POS system, it combines highly interactive terminal and tablet touchscreen applications supporting Windows, Android and iOS devices. Its robust reporting and analysis features, extensive enterprise-grade menu and item configuration capabilities, and multi-language support, help to drive service flexibility and increased operational efficiency.',
    ],
    img1: '/assets/higher-ed/solutions/InfoGenesis3.png',
    img2: '/assets/higher-ed/solutions/Infogenesis2.png',
  },
  'ig-kiosk': {
    pageClass: 'IGKioskFPage',
    logo: '/assets/higher-ed/solutions/AgilysysIGKiosk.svg',
    logoAlt: 'Agilysys IG Kiosk',
    videoUrl: BASE_VIDEO + 'InteractiveIGKiosk.mp4',
    texts: [
      "A self-service F&B ordering kiosk that integrates with InfoGenesis POS to serve residents 24-7. Diners casually select menu items, process their credit card payment and print a receipt \u2013 all using a simple interface. No service staff required, reducing the time it takes to serve each diner.\n\nFor those who want to make their own choices, on their own time, IG Kiosk offers the freedom to browse menu options whenever it\u2019s most convenient. Perfect for Grab N Go, cafeterias and fast service restaurants.\n\nThe result is improved service, increased efficiency and reduced operating costs.",
    ],
    img1: '/assets/higher-ed/solutions/IGKiosk1.png',
    img2: '/assets/higher-ed/solutions/IGKiosk2.png',
  },
  'ig-on-demand': {
    pageClass: 'IGOnDemandFPage',
    logo: '/assets/higher-ed/solutions/AgilysysIGOnDemand.svg',
    logoAlt: 'Agilysys IG OnDemand',
    videoUrl: BASE_VIDEO + 'InteractiveIGOnDemand2.mp4',
    texts: [
      "A complete cloud-native contactless self-service F&B ordering solution that offers an intuitive student and faculty-facing order and pay experience. IG OnDemand allows diners to place and pay for orders using their own device \u2013 phone, tablet, laptop \u2013 for pick-up or delivery orders, as well as for a table-side order and pay experience.\n\nIt supports ordering for multiple diners at a table over the course of a meal using their own devices making the ordering process touchless while freeing up staff to spend more time with students and faculty. The result is increased order volume and check size, higher satisfaction scores and more personalized service.",
    ],
    img1: '/assets/higher-ed/solutions/IGOnDemand1.png',
    img2: '/assets/higher-ed/solutions/IGOnDemand2.png',
  },
  'digital-menu': {
    pageClass: 'digitalMenuFPage',
    logo: '/assets/higher-ed/solutions/AgilysysIGDigitalMenu.svg',
    logoAlt: 'Agilysys IG Digital Menu Board',
    texts: [
      'IG Digital Menu Board provides a cloud-native large-format digital display on industry standard technology to present high quality images and menus for a variety of venues.',
      'It allows users to create and design layouts using pre-defined templates, and schedule menus with auto-update at defined times for a specified menu list. It also supports rotating menus with promo prices for items and combos.',
    ],
    img1: '/assets/higher-ed/solutions/digitalMenu1.png',
  },
  sales: {
    pageClass: 'salesFPage',
    logo: '/assets/higher-ed/solutions/AgilysysSalesAndCatering.svg',
    logoAlt: 'Agilysys Sales & Catering',
    texts: [
      'A cloud-native comprehensive sales & event management system that provides powerful tools for higher education institutions of all sizes. With a complete view of every group and event, the system fully exposes the value of each attendee and group across meeting and shoulder dates.',
      'The result is improved event revenue opportunities and streamlined management enabling event planners and sales teams to more efficiently sell, manage and service their clients.',
    ],
    img1: '/assets/higher-ed/solutions/Catering1.png',
  },
};

function Solution() {
  const { id } = useParams();
  const sol = SOLUTIONS[id];
  const [showPopup, setShowPopup] = useState(false);

  if (!sol) {
    return <div className="page"><div className="page-header">Solution Not Found</div></div>;
  }

  return (
    <div className={`page splash ${sol.pageClass}`}>
      <div className="page-title">
        <img src={sol.logo} alt={sol.logoAlt} />
      </div>

      <div className="text-blocks">
        {sol.texts.map((t, i) => (
          <div key={i} className="std-text">{t}</div>
        ))}
      </div>

      {sol.videoUrl && (
        <div className="play-video" onClick={() => setShowPopup(true)}>
          <PlayIcon />
          Play Video
        </div>
      )}

      {sol.img1 && <img className="img-1" src={sol.img1} alt="" />}
      {sol.img2 && <img className="img-2" src={sol.img2} alt="" />}

      {showPopup && (
        <div className="popup" style={{ display: 'flex' }}>
          <div className="offclick" onClick={() => setShowPopup(false)} />
          <div className="close" onClick={() => setShowPopup(false)}>
            <CloseIcon />
          </div>
          <div className="holder" style={{ width: '85vw', maxWidth: '1200px', maxHeight: '85vh', aspectRatio: '16/9' }}>
            <video
              autoPlay
              controls
              src={sol.videoUrl}
              style={{ width: '100%', height: '100%', display: 'block' }}
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default Solution;
